export default "__VITE_ASSET__D4CsErGB__"